module.exports = __webpack_public_path__ + "static/media/godsel.b4d7d0ed.mp3";